/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  CreatePinboardCardAttachmentInput,
  CreatePinboardListInput,
  ListPinboardBoardActivitiesParams,
  MovePinboardListInput,
  PinboardBoard,
  PinboardBoardActivity,
  PinboardBoardCard,
  PinboardBoardList,
  PinboardBoardRequestInput,
  PinboardCardCommentRequestInput,
  PinboardCardRequestInput,
  SchemaValidationErrorResponse,
  UpdatePinboardCardAttachmentInput,
  UpdatePinboardListInput,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Delete an attachment
 */
export const deletePinboardCardAttachment = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<PinboardBoardCard>(
      {url: `/pinboard/attachments/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeletePinboardCardAttachmentMutationKey = () => ['deletePinboardCardAttachment'] as const;

export const getDeletePinboardCardAttachmentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePinboardCardAttachment>>, TError,DeletePinboardCardAttachmentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePinboardCardAttachment>>, TError,DeletePinboardCardAttachmentMutationVariables, TContext> => {

const mutationKey = getDeletePinboardCardAttachmentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePinboardCardAttachment>>, DeletePinboardCardAttachmentMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deletePinboardCardAttachment(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePinboardCardAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof deletePinboardCardAttachment>>>

    export type DeletePinboardCardAttachmentMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeletePinboardCardAttachmentMutationVariables = {id: string}

    /**
 * @summary Delete an attachment
 */
export const useDeletePinboardCardAttachment = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePinboardCardAttachment>>, TError,DeletePinboardCardAttachmentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deletePinboardCardAttachment>>,
        TError,
        DeletePinboardCardAttachmentMutationVariables,
        TContext
      > => {
      return useMutation(getDeletePinboardCardAttachmentMutationOptions(options), queryClient);
    }
    /**
 * @summary Update an attachment
 */
export const updatePinboardCardAttachment = (
    id: MaybeRefOrGetter<string>,
    updatePinboardCardAttachmentInput: MaybeRefOrGetter<UpdatePinboardCardAttachmentInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
updatePinboardCardAttachmentInput = toValue(updatePinboardCardAttachmentInput);

      return axiosClient<PinboardBoardCard>(
      {url: `/pinboard/attachments/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePinboardCardAttachmentInput, signal
    },
      );
    }




export const getUpdatePinboardCardAttachmentMutationKey = () => ['updatePinboardCardAttachment'] as const;

export const getUpdatePinboardCardAttachmentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePinboardCardAttachment>>, TError,UpdatePinboardCardAttachmentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePinboardCardAttachment>>, TError,UpdatePinboardCardAttachmentMutationVariables, TContext> => {

const mutationKey = getUpdatePinboardCardAttachmentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePinboardCardAttachment>>, UpdatePinboardCardAttachmentMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updatePinboardCardAttachment(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePinboardCardAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof updatePinboardCardAttachment>>>
    export type UpdatePinboardCardAttachmentMutationBody = UpdatePinboardCardAttachmentInput
    export type UpdatePinboardCardAttachmentMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type UpdatePinboardCardAttachmentMutationVariables = {id: string;data: UpdatePinboardCardAttachmentInput}

    /**
 * @summary Update an attachment
 */
export const useUpdatePinboardCardAttachment = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePinboardCardAttachment>>, TError,UpdatePinboardCardAttachmentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updatePinboardCardAttachment>>,
        TError,
        UpdatePinboardCardAttachmentMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePinboardCardAttachmentMutationOptions(options), queryClient);
    }
    /**
 * @summary Create Board
 */
export const createPinboardBoard = (

 signal?: AbortSignal
) => {


      return axiosClient<PinboardBoard>(
      {url: `/pinboard/boards`, method: 'POST', signal
    },
      );
    }




export const getCreatePinboardBoardMutationKey = () => ['createPinboardBoard'] as const;

export const getCreatePinboardBoardMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPinboardBoard>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPinboardBoard>>, TError,void, TContext> => {

const mutationKey = getCreatePinboardBoardMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPinboardBoard>>, void> = () => {


          return  createPinboardBoard()
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePinboardBoardMutationResult = NonNullable<Awaited<ReturnType<typeof createPinboardBoard>>>

    export type CreatePinboardBoardMutationError = ErrorType<void>


    /**
 * @summary Create Board
 */
export const useCreatePinboardBoard = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPinboardBoard>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createPinboardBoard>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreatePinboardBoardMutationOptions(options), queryClient);
    }
    /**
 * @summary List all activities for a board
 */
export const listPinboardBoardActivities = (
    boardId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListPinboardBoardActivitiesParams>,
 signal?: AbortSignal
) => {
      boardId = toValue(boardId);
params = toValue(params);

      return axiosClient<PinboardBoardActivity[]>(
      {url: `/pinboard/boards/${boardId}/activities`, method: 'GET',
        params, signal
    },
      );
    }




export const getListPinboardBoardActivitiesQueryKey = (boardId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListPinboardBoardActivitiesParams>,) => {
    return [
    'pinboard','boards',boardId,'activities', ...(params ? [params] : [])
    ] as const;
    }


export const getListPinboardBoardActivitiesQueryOptions = <TData = Awaited<ReturnType<typeof listPinboardBoardActivities>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(boardId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListPinboardBoardActivitiesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPinboardBoardActivities>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListPinboardBoardActivitiesQueryKey(boardId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPinboardBoardActivities>>> = ({ signal }) => listPinboardBoardActivities(boardId,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(boardId) !== null && toValue(boardId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPinboardBoardActivities>>, TError, TData>
}

export type ListPinboardBoardActivitiesQueryResult = NonNullable<Awaited<ReturnType<typeof listPinboardBoardActivities>>>
export type ListPinboardBoardActivitiesQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List all activities for a board
 */

export function useListPinboardBoardActivities<TData = Awaited<ReturnType<typeof listPinboardBoardActivities>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 boardId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListPinboardBoardActivitiesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPinboardBoardActivities>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPinboardBoardActivitiesQueryOptions(boardId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Create a new list
 */
export const createPinboardList = (
    boardId: MaybeRefOrGetter<string>,
    createPinboardListInput: MaybeRefOrGetter<CreatePinboardListInput>,
 signal?: AbortSignal
) => {
      boardId = toValue(boardId);
createPinboardListInput = toValue(createPinboardListInput);

      return axiosClient<PinboardBoardList>(
      {url: `/pinboard/boards/${boardId}/lists`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPinboardListInput, signal
    },
      );
    }




export const getCreatePinboardListMutationKey = () => ['createPinboardList'] as const;

export const getCreatePinboardListMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPinboardList>>, TError,CreatePinboardListMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPinboardList>>, TError,CreatePinboardListMutationVariables, TContext> => {

const mutationKey = getCreatePinboardListMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPinboardList>>, CreatePinboardListMutationVariables> = (props) => {
          const {boardId,data} = props ?? {};

          return  createPinboardList(boardId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePinboardListMutationResult = NonNullable<Awaited<ReturnType<typeof createPinboardList>>>
    export type CreatePinboardListMutationBody = CreatePinboardListInput
    export type CreatePinboardListMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type CreatePinboardListMutationVariables = {boardId: string;data: CreatePinboardListInput}

    /**
 * @summary Create a new list
 */
export const useCreatePinboardList = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPinboardList>>, TError,CreatePinboardListMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createPinboardList>>,
        TError,
        CreatePinboardListMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePinboardListMutationOptions(options), queryClient);
    }
    /**
 * @summary Remove a member from a board
 */
export const deletePinboardBoardMember = (
    boardId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      boardId = toValue(boardId);
id = toValue(id);

      return axiosClient<PinboardBoard>(
      {url: `/pinboard/boards/${boardId}/members/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeletePinboardBoardMemberMutationKey = () => ['deletePinboardBoardMember'] as const;

export const getDeletePinboardBoardMemberMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePinboardBoardMember>>, TError,DeletePinboardBoardMemberMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePinboardBoardMember>>, TError,DeletePinboardBoardMemberMutationVariables, TContext> => {

const mutationKey = getDeletePinboardBoardMemberMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePinboardBoardMember>>, DeletePinboardBoardMemberMutationVariables> = (props) => {
          const {boardId,id} = props ?? {};

          return  deletePinboardBoardMember(boardId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePinboardBoardMemberMutationResult = NonNullable<Awaited<ReturnType<typeof deletePinboardBoardMember>>>

    export type DeletePinboardBoardMemberMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeletePinboardBoardMemberMutationVariables = {boardId: string;id: string}

    /**
 * @summary Remove a member from a board
 */
export const useDeletePinboardBoardMember = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePinboardBoardMember>>, TError,DeletePinboardBoardMemberMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deletePinboardBoardMember>>,
        TError,
        DeletePinboardBoardMemberMutationVariables,
        TContext
      > => {
      return useMutation(getDeletePinboardBoardMemberMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Board
 */
export const deletePinboardBoard = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/pinboard/boards/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeletePinboardBoardMutationKey = () => ['deletePinboardBoard'] as const;

export const getDeletePinboardBoardMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePinboardBoard>>, TError,DeletePinboardBoardMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePinboardBoard>>, TError,DeletePinboardBoardMutationVariables, TContext> => {

const mutationKey = getDeletePinboardBoardMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePinboardBoard>>, DeletePinboardBoardMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deletePinboardBoard(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePinboardBoardMutationResult = NonNullable<Awaited<ReturnType<typeof deletePinboardBoard>>>

    export type DeletePinboardBoardMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeletePinboardBoardMutationVariables = {id: string}

    /**
 * @summary Delete Board
 */
export const useDeletePinboardBoard = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePinboardBoard>>, TError,DeletePinboardBoardMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deletePinboardBoard>>,
        TError,
        DeletePinboardBoardMutationVariables,
        TContext
      > => {
      return useMutation(getDeletePinboardBoardMutationOptions(options), queryClient);
    }
    /**
 * @summary Board Details
 */
export const getPinboardBoard = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<PinboardBoard>(
      {url: `/pinboard/boards/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetPinboardBoardQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'pinboard','boards',id
    ] as const;
    }


export const getGetPinboardBoardQueryOptions = <TData = Awaited<ReturnType<typeof getPinboardBoard>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPinboardBoard>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetPinboardBoardQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPinboardBoard>>> = ({ signal }) => getPinboardBoard(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPinboardBoard>>, TError, TData>
}

export type GetPinboardBoardQueryResult = NonNullable<Awaited<ReturnType<typeof getPinboardBoard>>>
export type GetPinboardBoardQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Board Details
 */

export function useGetPinboardBoard<TData = Awaited<ReturnType<typeof getPinboardBoard>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPinboardBoard>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPinboardBoardQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Board
 */
export const updatePinboardBoard = (
    id: MaybeRefOrGetter<string>,
    pinboardBoardRequestInput: MaybeRefOrGetter<PinboardBoardRequestInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
pinboardBoardRequestInput = toValue(pinboardBoardRequestInput);

      return axiosClient<PinboardBoard>(
      {url: `/pinboard/boards/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: pinboardBoardRequestInput, signal
    },
      );
    }




export const getUpdatePinboardBoardMutationKey = () => ['updatePinboardBoard'] as const;

export const getUpdatePinboardBoardMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePinboardBoard>>, TError,UpdatePinboardBoardMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePinboardBoard>>, TError,UpdatePinboardBoardMutationVariables, TContext> => {

const mutationKey = getUpdatePinboardBoardMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePinboardBoard>>, UpdatePinboardBoardMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updatePinboardBoard(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePinboardBoardMutationResult = NonNullable<Awaited<ReturnType<typeof updatePinboardBoard>>>
    export type UpdatePinboardBoardMutationBody = PinboardBoardRequestInput
    export type UpdatePinboardBoardMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type UpdatePinboardBoardMutationVariables = {id: string;data: PinboardBoardRequestInput}

    /**
 * @summary Update Board
 */
export const useUpdatePinboardBoard = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePinboardBoard>>, TError,UpdatePinboardBoardMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updatePinboardBoard>>,
        TError,
        UpdatePinboardBoardMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePinboardBoardMutationOptions(options), queryClient);
    }
    /**
 * @summary Create an attachment for a card
 */
export const createPinboardCardAttachment = (
    cardId: MaybeRefOrGetter<string>,
    createPinboardCardAttachmentInput: MaybeRefOrGetter<CreatePinboardCardAttachmentInput>,
 signal?: AbortSignal
) => {
      cardId = toValue(cardId);
createPinboardCardAttachmentInput = toValue(createPinboardCardAttachmentInput);

      return axiosClient<PinboardBoardCard>(
      {url: `/pinboard/cards/${cardId}/attachments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPinboardCardAttachmentInput, signal
    },
      );
    }




export const getCreatePinboardCardAttachmentMutationKey = () => ['createPinboardCardAttachment'] as const;

export const getCreatePinboardCardAttachmentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPinboardCardAttachment>>, TError,CreatePinboardCardAttachmentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPinboardCardAttachment>>, TError,CreatePinboardCardAttachmentMutationVariables, TContext> => {

const mutationKey = getCreatePinboardCardAttachmentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPinboardCardAttachment>>, CreatePinboardCardAttachmentMutationVariables> = (props) => {
          const {cardId,data} = props ?? {};

          return  createPinboardCardAttachment(cardId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePinboardCardAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof createPinboardCardAttachment>>>
    export type CreatePinboardCardAttachmentMutationBody = CreatePinboardCardAttachmentInput
    export type CreatePinboardCardAttachmentMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type CreatePinboardCardAttachmentMutationVariables = {cardId: string;data: CreatePinboardCardAttachmentInput}

    /**
 * @summary Create an attachment for a card
 */
export const useCreatePinboardCardAttachment = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPinboardCardAttachment>>, TError,CreatePinboardCardAttachmentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createPinboardCardAttachment>>,
        TError,
        CreatePinboardCardAttachmentMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePinboardCardAttachmentMutationOptions(options), queryClient);
    }
    /**
 * @summary Create a comment for a card
 */
export const createPinboardCardComment = (
    cardId: MaybeRefOrGetter<string>,
    pinboardCardCommentRequestInput: MaybeRefOrGetter<PinboardCardCommentRequestInput>,
 signal?: AbortSignal
) => {
      cardId = toValue(cardId);
pinboardCardCommentRequestInput = toValue(pinboardCardCommentRequestInput);

      return axiosClient<PinboardBoardCard>(
      {url: `/pinboard/cards/${cardId}/comments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pinboardCardCommentRequestInput, signal
    },
      );
    }




export const getCreatePinboardCardCommentMutationKey = () => ['createPinboardCardComment'] as const;

export const getCreatePinboardCardCommentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPinboardCardComment>>, TError,CreatePinboardCardCommentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPinboardCardComment>>, TError,CreatePinboardCardCommentMutationVariables, TContext> => {

const mutationKey = getCreatePinboardCardCommentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPinboardCardComment>>, CreatePinboardCardCommentMutationVariables> = (props) => {
          const {cardId,data} = props ?? {};

          return  createPinboardCardComment(cardId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePinboardCardCommentMutationResult = NonNullable<Awaited<ReturnType<typeof createPinboardCardComment>>>
    export type CreatePinboardCardCommentMutationBody = PinboardCardCommentRequestInput
    export type CreatePinboardCardCommentMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type CreatePinboardCardCommentMutationVariables = {cardId: string;data: PinboardCardCommentRequestInput}

    /**
 * @summary Create a comment for a card
 */
export const useCreatePinboardCardComment = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPinboardCardComment>>, TError,CreatePinboardCardCommentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createPinboardCardComment>>,
        TError,
        CreatePinboardCardCommentMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePinboardCardCommentMutationOptions(options), queryClient);
    }
    /**
 * @summary Move a card to a new position or list
 */
export const movePinboardCard = (
    cardId: MaybeRefOrGetter<string>,
    pinboardCardRequestInput: MaybeRefOrGetter<PinboardCardRequestInput>,
 signal?: AbortSignal
) => {
      cardId = toValue(cardId);
pinboardCardRequestInput = toValue(pinboardCardRequestInput);

      return axiosClient<PinboardBoardCard>(
      {url: `/pinboard/cards/${cardId}/move`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: pinboardCardRequestInput, signal
    },
      );
    }




export const getMovePinboardCardMutationKey = () => ['movePinboardCard'] as const;

export const getMovePinboardCardMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof movePinboardCard>>, TError,MovePinboardCardMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof movePinboardCard>>, TError,MovePinboardCardMutationVariables, TContext> => {

const mutationKey = getMovePinboardCardMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof movePinboardCard>>, MovePinboardCardMutationVariables> = (props) => {
          const {cardId,data} = props ?? {};

          return  movePinboardCard(cardId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MovePinboardCardMutationResult = NonNullable<Awaited<ReturnType<typeof movePinboardCard>>>
    export type MovePinboardCardMutationBody = PinboardCardRequestInput
    export type MovePinboardCardMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type MovePinboardCardMutationVariables = {cardId: string;data: PinboardCardRequestInput}

    /**
 * @summary Move a card to a new position or list
 */
export const useMovePinboardCard = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof movePinboardCard>>, TError,MovePinboardCardMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof movePinboardCard>>,
        TError,
        MovePinboardCardMutationVariables,
        TContext
      > => {
      return useMutation(getMovePinboardCardMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete a card
 */
export const deletePinboardCard = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/pinboard/cards/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeletePinboardCardMutationKey = () => ['deletePinboardCard'] as const;

export const getDeletePinboardCardMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePinboardCard>>, TError,DeletePinboardCardMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePinboardCard>>, TError,DeletePinboardCardMutationVariables, TContext> => {

const mutationKey = getDeletePinboardCardMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePinboardCard>>, DeletePinboardCardMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deletePinboardCard(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePinboardCardMutationResult = NonNullable<Awaited<ReturnType<typeof deletePinboardCard>>>

    export type DeletePinboardCardMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeletePinboardCardMutationVariables = {id: string}

    /**
 * @summary Delete a card
 */
export const useDeletePinboardCard = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePinboardCard>>, TError,DeletePinboardCardMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deletePinboardCard>>,
        TError,
        DeletePinboardCardMutationVariables,
        TContext
      > => {
      return useMutation(getDeletePinboardCardMutationOptions(options), queryClient);
    }
    /**
 * @summary Get card details
 */
export const getPinboardCard = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<PinboardBoardCard>(
      {url: `/pinboard/cards/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetPinboardCardQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'pinboard','cards',id
    ] as const;
    }


export const getGetPinboardCardQueryOptions = <TData = Awaited<ReturnType<typeof getPinboardCard>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPinboardCard>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetPinboardCardQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPinboardCard>>> = ({ signal }) => getPinboardCard(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPinboardCard>>, TError, TData>
}

export type GetPinboardCardQueryResult = NonNullable<Awaited<ReturnType<typeof getPinboardCard>>>
export type GetPinboardCardQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Get card details
 */

export function useGetPinboardCard<TData = Awaited<ReturnType<typeof getPinboardCard>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPinboardCard>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPinboardCardQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update a card
 */
export const updatePinboardCard = (
    id: MaybeRefOrGetter<string>,
    pinboardCardRequestInput: MaybeRefOrGetter<PinboardCardRequestInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
pinboardCardRequestInput = toValue(pinboardCardRequestInput);

      return axiosClient<PinboardBoardCard>(
      {url: `/pinboard/cards/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: pinboardCardRequestInput, signal
    },
      );
    }




export const getUpdatePinboardCardMutationKey = () => ['updatePinboardCard'] as const;

export const getUpdatePinboardCardMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePinboardCard>>, TError,UpdatePinboardCardMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePinboardCard>>, TError,UpdatePinboardCardMutationVariables, TContext> => {

const mutationKey = getUpdatePinboardCardMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePinboardCard>>, UpdatePinboardCardMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updatePinboardCard(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePinboardCardMutationResult = NonNullable<Awaited<ReturnType<typeof updatePinboardCard>>>
    export type UpdatePinboardCardMutationBody = PinboardCardRequestInput
    export type UpdatePinboardCardMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type UpdatePinboardCardMutationVariables = {id: string;data: PinboardCardRequestInput}

    /**
 * @summary Update a card
 */
export const useUpdatePinboardCard = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePinboardCard>>, TError,UpdatePinboardCardMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updatePinboardCard>>,
        TError,
        UpdatePinboardCardMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePinboardCardMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete a comment
 */
export const deletePinboardCardComment = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<PinboardBoardCard>(
      {url: `/pinboard/comments/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeletePinboardCardCommentMutationKey = () => ['deletePinboardCardComment'] as const;

export const getDeletePinboardCardCommentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePinboardCardComment>>, TError,DeletePinboardCardCommentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePinboardCardComment>>, TError,DeletePinboardCardCommentMutationVariables, TContext> => {

const mutationKey = getDeletePinboardCardCommentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePinboardCardComment>>, DeletePinboardCardCommentMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deletePinboardCardComment(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePinboardCardCommentMutationResult = NonNullable<Awaited<ReturnType<typeof deletePinboardCardComment>>>

    export type DeletePinboardCardCommentMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeletePinboardCardCommentMutationVariables = {id: string}

    /**
 * @summary Delete a comment
 */
export const useDeletePinboardCardComment = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePinboardCardComment>>, TError,DeletePinboardCardCommentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deletePinboardCardComment>>,
        TError,
        DeletePinboardCardCommentMutationVariables,
        TContext
      > => {
      return useMutation(getDeletePinboardCardCommentMutationOptions(options), queryClient);
    }
    /**
 * @summary Update a comment
 */
export const updatePinboardCardComment = (
    id: MaybeRefOrGetter<string>,
    pinboardCardCommentRequestInput: MaybeRefOrGetter<PinboardCardCommentRequestInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
pinboardCardCommentRequestInput = toValue(pinboardCardCommentRequestInput);

      return axiosClient<PinboardBoardCard>(
      {url: `/pinboard/comments/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: pinboardCardCommentRequestInput, signal
    },
      );
    }




export const getUpdatePinboardCardCommentMutationKey = () => ['updatePinboardCardComment'] as const;

export const getUpdatePinboardCardCommentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePinboardCardComment>>, TError,UpdatePinboardCardCommentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePinboardCardComment>>, TError,UpdatePinboardCardCommentMutationVariables, TContext> => {

const mutationKey = getUpdatePinboardCardCommentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePinboardCardComment>>, UpdatePinboardCardCommentMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updatePinboardCardComment(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePinboardCardCommentMutationResult = NonNullable<Awaited<ReturnType<typeof updatePinboardCardComment>>>
    export type UpdatePinboardCardCommentMutationBody = PinboardCardCommentRequestInput
    export type UpdatePinboardCardCommentMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdatePinboardCardCommentMutationVariables = {id: string;data: PinboardCardCommentRequestInput}

    /**
 * @summary Update a comment
 */
export const useUpdatePinboardCardComment = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePinboardCardComment>>, TError,UpdatePinboardCardCommentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updatePinboardCardComment>>,
        TError,
        UpdatePinboardCardCommentMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePinboardCardCommentMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete a list
 */
export const deletePinboardList = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/pinboard/lists/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeletePinboardListMutationKey = () => ['deletePinboardList'] as const;

export const getDeletePinboardListMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePinboardList>>, TError,DeletePinboardListMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePinboardList>>, TError,DeletePinboardListMutationVariables, TContext> => {

const mutationKey = getDeletePinboardListMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePinboardList>>, DeletePinboardListMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deletePinboardList(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePinboardListMutationResult = NonNullable<Awaited<ReturnType<typeof deletePinboardList>>>

    export type DeletePinboardListMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeletePinboardListMutationVariables = {id: string}

    /**
 * @summary Delete a list
 */
export const useDeletePinboardList = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePinboardList>>, TError,DeletePinboardListMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deletePinboardList>>,
        TError,
        DeletePinboardListMutationVariables,
        TContext
      > => {
      return useMutation(getDeletePinboardListMutationOptions(options), queryClient);
    }
    /**
 * @summary Get list details
 */
export const getPinboardList = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<PinboardBoardList>(
      {url: `/pinboard/lists/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetPinboardListQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'pinboard','lists',id
    ] as const;
    }


export const getGetPinboardListQueryOptions = <TData = Awaited<ReturnType<typeof getPinboardList>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPinboardList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetPinboardListQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPinboardList>>> = ({ signal }) => getPinboardList(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPinboardList>>, TError, TData>
}

export type GetPinboardListQueryResult = NonNullable<Awaited<ReturnType<typeof getPinboardList>>>
export type GetPinboardListQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Get list details
 */

export function useGetPinboardList<TData = Awaited<ReturnType<typeof getPinboardList>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPinboardList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPinboardListQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update a list
 */
export const updatePinboardList = (
    id: MaybeRefOrGetter<string>,
    updatePinboardListInput: MaybeRefOrGetter<UpdatePinboardListInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
updatePinboardListInput = toValue(updatePinboardListInput);

      return axiosClient<PinboardBoardList>(
      {url: `/pinboard/lists/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePinboardListInput, signal
    },
      );
    }




export const getUpdatePinboardListMutationKey = () => ['updatePinboardList'] as const;

export const getUpdatePinboardListMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePinboardList>>, TError,UpdatePinboardListMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePinboardList>>, TError,UpdatePinboardListMutationVariables, TContext> => {

const mutationKey = getUpdatePinboardListMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePinboardList>>, UpdatePinboardListMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updatePinboardList(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePinboardListMutationResult = NonNullable<Awaited<ReturnType<typeof updatePinboardList>>>
    export type UpdatePinboardListMutationBody = UpdatePinboardListInput
    export type UpdatePinboardListMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type UpdatePinboardListMutationVariables = {id: string;data: UpdatePinboardListInput}

    /**
 * @summary Update a list
 */
export const useUpdatePinboardList = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePinboardList>>, TError,UpdatePinboardListMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updatePinboardList>>,
        TError,
        UpdatePinboardListMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePinboardListMutationOptions(options), queryClient);
    }
    /**
 * @summary Create a new card
 */
export const createPinboardCard = (
    listId: MaybeRefOrGetter<string>,
    pinboardCardRequestInput: MaybeRefOrGetter<PinboardCardRequestInput>,
 signal?: AbortSignal
) => {
      listId = toValue(listId);
pinboardCardRequestInput = toValue(pinboardCardRequestInput);

      return axiosClient<PinboardBoardCard>(
      {url: `/pinboard/lists/${listId}/cards`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pinboardCardRequestInput, signal
    },
      );
    }




export const getCreatePinboardCardMutationKey = () => ['createPinboardCard'] as const;

export const getCreatePinboardCardMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPinboardCard>>, TError,CreatePinboardCardMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPinboardCard>>, TError,CreatePinboardCardMutationVariables, TContext> => {

const mutationKey = getCreatePinboardCardMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPinboardCard>>, CreatePinboardCardMutationVariables> = (props) => {
          const {listId,data} = props ?? {};

          return  createPinboardCard(listId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePinboardCardMutationResult = NonNullable<Awaited<ReturnType<typeof createPinboardCard>>>
    export type CreatePinboardCardMutationBody = PinboardCardRequestInput
    export type CreatePinboardCardMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type CreatePinboardCardMutationVariables = {listId: string;data: PinboardCardRequestInput}

    /**
 * @summary Create a new card
 */
export const useCreatePinboardCard = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPinboardCard>>, TError,CreatePinboardCardMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createPinboardCard>>,
        TError,
        CreatePinboardCardMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePinboardCardMutationOptions(options), queryClient);
    }
    /**
 * @summary Move a list to a new position
 */
export const movePinboardList = (
    listId: MaybeRefOrGetter<string>,
    movePinboardListInput: MaybeRefOrGetter<MovePinboardListInput>,
 signal?: AbortSignal
) => {
      listId = toValue(listId);
movePinboardListInput = toValue(movePinboardListInput);

      return axiosClient<PinboardBoardList>(
      {url: `/pinboard/lists/${listId}/move`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: movePinboardListInput, signal
    },
      );
    }




export const getMovePinboardListMutationKey = () => ['movePinboardList'] as const;

export const getMovePinboardListMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof movePinboardList>>, TError,MovePinboardListMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof movePinboardList>>, TError,MovePinboardListMutationVariables, TContext> => {

const mutationKey = getMovePinboardListMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof movePinboardList>>, MovePinboardListMutationVariables> = (props) => {
          const {listId,data} = props ?? {};

          return  movePinboardList(listId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MovePinboardListMutationResult = NonNullable<Awaited<ReturnType<typeof movePinboardList>>>
    export type MovePinboardListMutationBody = MovePinboardListInput
    export type MovePinboardListMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type MovePinboardListMutationVariables = {listId: string;data: MovePinboardListInput}

    /**
 * @summary Move a list to a new position
 */
export const useMovePinboardList = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof movePinboardList>>, TError,MovePinboardListMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof movePinboardList>>,
        TError,
        MovePinboardListMutationVariables,
        TContext
      > => {
      return useMutation(getMovePinboardListMutationOptions(options), queryClient);
    }
